import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_ENV } from '@auth/app/core/tokens';
import { AuthService } from '@auth/app/core/services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const env = inject(AUTH_ENV);

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([env.loginPath], {
    queryParams: { returnUrl: state.url },
  });
};
